import React from "react";
import ReactDOMServer from "react-dom/server";
import { Icon, Style } from "ol/style";
import { ReactComponent as TruckMarkerIcon } from "../img/TruckMarkerIcon.svg";
import { ReactComponent as ActiveOrderMarker } from "../img/ActiveOrderMarker.svg";

const DRIVER_ONLINE_COLOR = "#1CE783";
const DRIVER_OFFLINE_COLOR = "#9CA3AF";

function toSvgDataUri(svgMarkup) {
  return `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(svgMarkup)}`;
}

export function createDriverMarkerAssets() {
  const onlineSvg = ReactDOMServer.renderToStaticMarkup(
    <TruckMarkerIcon fill={DRIVER_ONLINE_COLOR} width={40} height={40} />
  );
  const offlineSvg = ReactDOMServer.renderToStaticMarkup(
    <TruckMarkerIcon fill={DRIVER_OFFLINE_COLOR} width={40} height={40} />
  );
  const activeOrderSvg = ReactDOMServer.renderToStaticMarkup(
    <ActiveOrderMarker width={18} height={18} />
  );

  return {
    online: toSvgDataUri(onlineSvg),
    offline: toSvgDataUri(offlineSvg),
    activeOrder: toSvgDataUri(activeOrderSvg),
  };
}

export function createDriverMarkerStyles() {
  const assets = createDriverMarkerAssets();
  return {
    online: new Style({
      image: new Icon({
        src: assets.online,
        anchor: [0.5, 1],
        anchorXUnits: "fraction",
        anchorYUnits: "fraction",
        crossOrigin: "anonymous",
      }),
      zIndex: 20,
    }),
    offline: new Style({
      image: new Icon({
        src: assets.offline,
        anchor: [0.5, 1],
        anchorXUnits: "fraction",
        anchorYUnits: "fraction",
        crossOrigin: "anonymous",
      }),
      zIndex: 20,
    }),
    activeOrderBadge: new Style({
      image: new Icon({
        src: assets.activeOrder,
        anchor: [0.1, 1.12],
        anchorXUnits: "fraction",
        anchorYUnits: "fraction",
        crossOrigin: "anonymous",
      }),
      zIndex: 30,
    }),
  };
}

export function resolveDriverMarkerState(point = {}, layer = {}) {
  const isOnlineRaw = point.isOnline ?? layer.isOnline;
  const hasActiveOrderRaw =
    point.hasActiveOrder ??
    point.hasCurrentTransportOrder ??
    layer.hasActiveOrder ??
    layer.hasCurrentTransportOrder;

  return {
    isOnline: Boolean(isOnlineRaw),
    hasActiveOrder: Boolean(hasActiveOrderRaw),
  };
}

export function buildDriverMarkerStyleSet(driverMarkerStyles, driverState = {}) {
  const baseStyle = driverState.isOnline ? driverMarkerStyles.online : driverMarkerStyles.offline;
  return driverState.hasActiveOrder ? [baseStyle, driverMarkerStyles.activeOrderBadge] : [baseStyle];
}
